// Seda & Cenit — scripts propios (vanilla, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initSelectorVariantes();
  initContadores();
  initBloqueoMenu();
  initNieve();
});

// Navidad: nieve dorada muy suave (solo si la decoración está activa; respeta "reducir movimiento")
function initNieve() {
  if (!document.body.classList.contains('sc-navidad-on')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var lienzo = document.createElement('canvas');
  lienzo.id = 'sc-nieve';
  lienzo.setAttribute('aria-hidden', 'true');
  document.body.appendChild(lienzo);
  var g = lienzo.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
  var W = 0, H = 0, copos = [];
  function medir() {
    W = window.innerWidth; H = window.innerHeight;
    lienzo.width = W * dpr; lienzo.height = H * dpr;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function crear(arriba) {
    return {
      x: Math.random() * W,
      y: arriba ? -10 : Math.random() * H,
      r: 1 + Math.random() * 2.4,
      v: 0.22 + Math.random() * 0.55,
      f: Math.random() * Math.PI * 2,
      dx: 0.15 + Math.random() * 0.35,
      blanco: Math.random() < 0.35
    };
  }
  medir();
  var cantidad = W < 750 ? 26 : 52;
  for (var i = 0; i < cantidad; i++) copos.push(crear(false));
  window.addEventListener('resize', medir);
  function cuadro() {
    g.clearRect(0, 0, W, H);
    for (var i = 0; i < copos.length; i++) {
      var c = copos[i];
      c.y += c.v; c.f += 0.012; c.x += Math.sin(c.f) * c.dx;
      if (c.y > H + 10) copos[i] = crear(true);
      g.beginPath();
      g.arc(c.x, c.y, c.r, 0, Math.PI * 2);
      if (c.blanco) { g.fillStyle = 'rgba(255,255,255,0.9)'; g.shadowColor = 'rgba(151,128,103,0.55)'; g.shadowBlur = 3; }
      else { g.fillStyle = 'rgba(206,168,92,0.55)'; g.shadowColor = 'transparent'; g.shadowBlur = 0; }
      g.fill();
    }
    requestAnimationFrame(cuadro);
  }
  requestAnimationFrame(cuadro);
}

// iPhone ignora overflow:hidden del body: con el menú lateral abierto se frena el scroll de la página de fondo.
function initBloqueoMenu() {
  var menu = document.querySelector('header-drawer details');
  if (!menu) return;
  var inicioY = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length) inicioY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!menu.hasAttribute('open')) return;
    var zona = e.target && e.target.closest ? e.target.closest('.menu-drawer__navigation-container, .menu-drawer__inner-submenu') : null;
    if (!zona) { e.preventDefault(); return; }
    var bajando = e.touches[0].clientY > inicioY;
    var alTope = zona.scrollTop <= 0;
    var alFondo = zona.scrollTop + zona.clientHeight >= zona.scrollHeight - 1;
    if ((bajando && alTope) || (!bajando && alFondo)) e.preventDefault();
  }, { passive: false });
}

function initReveal() {
  var els = document.querySelectorAll('.sc-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-sc-delay') || 0;
        setTimeout(function () { entry.target.classList.add('sc-visible'); }, parseInt(delay, 10));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-sc-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-sc-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var selects = form.querySelectorAll('[data-sc-opcion]');
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-sc-precio-wrap]');
  var compareEl = form.querySelector('[data-sc-precio-anterior]');
  var botonEl = form.querySelector('[data-sc-boton-comprar]');
  var galeriaPrincipal = document.querySelector('[data-sc-galeria-principal]');
  var tarjetasAroma = form.querySelectorAll('input[name="sc-aroma"]');
  if (!selects.length) return;

  function moneda(centavos) {
    if (window.Shopify && Shopify.formatMoney && window.themeVariables) {
      try { return Shopify.formatMoney(centavos); } catch (e) {}
    }
    return (centavos / 100).toFixed(2);
  }

  function actualizar() {
    var elegidas = [];
    selects.forEach(function (s) { elegidas.push(s.value); });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === elegidas[i]; });
    });
    if (!match) return;
    inputId.value = match.id;
    tarjetasAroma.forEach(function (r) { r.checked = (r.value === elegidas[0]); });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState(null, '', url.toString());
    } catch (e) {}
    if (precioEl && match.price != null) precioEl.textContent = moneda(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = moneda(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (match.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible');
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado');
      }
    }
    if (galeriaPrincipal && match.image && galeriaPrincipal.src !== match.image) {
      galeriaPrincipal.style.opacity = '0';
      setTimeout(function () {
        galeriaPrincipal.src = match.image;
        galeriaPrincipal.alt = match.alt || galeriaPrincipal.alt;
        galeriaPrincipal.style.opacity = '1';
      }, 160);
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  tarjetasAroma.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      selects[0].value = r.value;
      actualizar();
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-sc-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-sc-contador'));
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var val = fin * (1 - Math.pow(1 - prog, 3));
        el.textContent = (fin % 1 === 0) ? Math.round(val) : val.toFixed(1);
        if (prog < 1) requestAnimationFrame(paso);
        else el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}
